import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ContainerState } from './types';

// The initial state of the Alert container
export const initialState: ContainerState = {
  open: false,
  errors: undefined
};

const formErrorSlice = createSlice({
  name: 'formError',
  initialState,
  reducers: {
    error(state, action: PayloadAction<string[]>) {
      state.open = true;
      state.errors = action.payload;
    },
    close(state) {
      state.open = false;
      delete state.errors;
    }
  }
});

export const { actions, reducer, name: sliceKey } = formErrorSlice;
export const { actions: FormErrorActions } = formErrorSlice;
